"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var HTTP_MAYBE_S_REGEX = /^https?:\/\//i;

var sanitizeURL = function sanitizeURL(url) {
  if (HTTP_MAYBE_S_REGEX.test(url)) {
    return url.replace(HTTP_MAYBE_S_REGEX, '');
  }

  return url;
};

var _default = sanitizeURL;
exports["default"] = _default;